import { pick } from 'Helpers/Affordances';
import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import BillingDetailsProfileSubpageRenewalDate from './BillingDetailsProfileSubpageRenewalDate/BillingDetailsProfileSubpageRenewalDate';

const BillingDetailsProfileSubpageRenewalDatePicker = ({ resource }) => {
  return pick(resource, {
    [fr.relationships.billingDetailsRenewalDate.name]: (<BillingDetailsProfileSubpageRenewalDate resource={resource} />),
  }, null);
};

BillingDetailsProfileSubpageRenewalDatePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
BillingDetailsProfileSubpageRenewalDatePicker.defaultProps = {};

export default BillingDetailsProfileSubpageRenewalDatePicker;
